import LayoutFooter, { getFooterDataSource } from "@/components/LayoutFooter";
import { getGrocery } from "@/services";
import useRequest from "@/utils/useReq";
import { Tabs } from "antd";
import { useRouter } from "next/router";
import { useCallback, useState } from "react";
import styles from "./index.module.less";

function Disclaimer({ data }) {
  return (
    <div className={styles.content}>
      <div className={styles.title}>{data.title}</div>
      <div dangerouslySetInnerHTML={{ __html: data.content }}></div>
    </div>
  );
}

export async function getServerSideProps({ req, query }) {
  const dataSource = await getFooterDataSource({
    query,
    seoLinkInfo: {
      currentUrl: req.url,
    },
  });
  return {
    props: {
      footerDataSource: dataSource,
    },
  };
}

export default function DisclaimerPage({ footerDataSource }) {
  const [list, setList] = useState([]);
  const router = useRouter();
  const activeKey = router.query.activeKey || "0";

  useRequest(async () => {
    const result = await getGrocery("about-disclaimer");
    if (result) {
      setList(result.list);
    }
  });

  const onChange = useCallback(
    (activeKey) => {
      router.push({
        pathname: "/about/disclaimer",
        query: { activeKey },
      });
    },
    [router]
  );

  return (
    <div className={styles.disclaimer}>
      <div
        style={{
          minHeight: `calc(100vh - var(--total-header-height, 0) - 33px)`,
        }}
      >
        <div className={styles.container}>
          <div className={styles.wrapper}>
            <Tabs activeKey={activeKey} tabPosition="left" onChange={onChange}>
              {list.map((item, index) => (
                <Tabs.TabPane tab={item.title} key={index}>
                  <Disclaimer data={item} />
                </Tabs.TabPane>
              ))}
            </Tabs>
          </div>
        </div>
      </div>
      <LayoutFooter dataSource={footerDataSource} />
    </div>
  );
}
